import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class AcquirerFilter extends Component {
    state = {
        acqBankList:[],
        acqBankValue: null,
        isLoading: true
    };
    componentDidMount(){
        this._get_acq_banks(this.props.report);
    }

    resetAcquirerFilter(){
        this.setState({
        acqBankValue: [],
        })
    }
     _get_acq_banks(report){
        axios.get(config.get('API_URL')+'/reports/acq-banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                report: report
            }
        }).then(response => {
            var that = this;
            if(Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    change_acq_banks(optionSelected){ //console.log(optionSelected);
        let value='';
        let acqBankArray = [];
        if(optionSelected.length<1){
            value = null;
            acqBankArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });

            });
        }

        this.props.onSelectAcquirer(optionSelected,acqBankArray);
        this.setState({
            acqBankValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="acqurier"
            isMulti
            value={this.state.acqBankValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.change_acq_banks.bind(this)}
            options={this.state.acqBankList}
            placeholderButtonLabel="Select [Acquirer]"
        />
        );

    }
}
export default AcquirerFilter;